import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const apiUrl = window._env_?.REACT_APP_API_URL || 'https://app.mylocaleventrentals.com/api';

const FeaturesContext = createContext({
  features: { contracts: false },
  contractsEnabled: false,
  loading: true,
  refreshFeatures: async () => {},
});

export function FeaturesProvider({ children }) {
  const { user, getToken } = useAuth();
  const [features, setFeatures] = useState({ contracts: false });
  const [loading, setLoading] = useState(true);

  const refreshFeatures = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setFeatures({ contracts: false });
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/user/profile`, {
        headers: { 'x-auth-token': token },
      });
      setFeatures(res.data.features || { contracts: false });
    } catch {
      setFeatures({ contracts: false });
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => {
    if (!user) {
      setFeatures({ contracts: false });
      setLoading(false);
      return;
    }
    refreshFeatures();
  }, [user, refreshFeatures]);

  const value = {
    features,
    contractsEnabled: Boolean(features.contracts),
    loading,
    refreshFeatures,
  };

  return (
    <FeaturesContext.Provider value={value}>
      {children}
    </FeaturesContext.Provider>
  );
}

export function useFeatures() {
  return useContext(FeaturesContext);
}
